var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 27,
    viewBox: "0 0 20 27",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15 12.9166667v1.4583333c0 .34375-.28125.625-.625.625h-8.75c-.34375 0-.625-.28125-.625-.625v-1.4583333c0-.34375.28125-.625.625-.625h8.75c.34375 0 .625.28125.625.625zm-.625 3.75h-8.75c-.34375 0-.625.28125-.625.625v1.4583333c0 .34375.28125.625.625.625h8.75c.34375 0 .625-.28125.625-.625v-1.4583333c0-.34375-.28125-.625-.625-.625zm5.625-9.79687503v17.29687503c0 1.3802083-1.1197917 2.5-2.5 2.5h-15c-1.38020833 0-2.5-1.1197917-2.5-2.5v-21.6666667c0-1.38020833 1.11979167-2.5 2.5-2.5h10.6302083c.6614584 0 1.296875.265625 1.765625.734375l4.3697917 4.36979167c.46875.46354166.734375 1.10416666.734375 1.765625zm-6.6666667-4.16666667v3.96354167h3.9635417zm4.1666667 21.4635417v-15.00000003h-5.4166667c-.6927083 0-1.25-.55729167-1.25-1.25v-5.41666667h-8.3333333v21.6666667z",
    fill: "#aaa"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.24997169.svg";
export { ForwardRef as ReactComponent };